import { Fragment, useState } from "react";
import { Plus, Search, X } from "react-feather";
import { Form, Input } from "reactstrap";
import ChatContactSetting from "./ChatContactSetting";
import { Href } from "../../../../Constants/Constants";

const ChatTitle = () => {
  const [chatContact, setChatContact] = useState(false);
  const [searchToggle, setSearchToggle] = useState(false);
  const toggleChatContact = () => setChatContact(!chatContact);
  return (
    <Fragment>
      <ChatContactSetting setChatContact={toggleChatContact} chatContact={chatContact} />
      <div className="template-title border-0">
        <div className="d-flex justify-content-between">
          <h3>Message (10)</h3>
          <div className="flex-grow-1">
            <a className="icon-btn btn-outline-light btn-sm search contact-search mt-0" href={Href} onClick={() => setSearchToggle(!searchToggle)}>
              <Search />
            </a>
            <Form className={`form-inline search-form ${searchToggle ? "open" : ""}`}>
              <div className="form-group">
                <Input className="form-control-plaintext" type="search" placeholder="Search.." />
                <div className="icon-close close-search" onClick={() => setSearchToggle(!searchToggle)}>
                  <X />
                </div>
              </div>
            </Form>
            <a className="icon-btn btn-primary btn-fix chat-cont-toggle outside" href={Href} onClick={toggleChatContact}>
              <Plus />
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChatTitle;
